/**
 * Add-to-cart: let the cart drawer do its job.
 * Something Splendid Co.
 * ---------------------------------------------------------------------------
 * THE PROBLEM
 *
 * assets/theme.js binds one global handler to every add-to-cart form:
 *
 *   $(document).on("submit", 'form[action="/cart/add"]', function (event) {
 *     ...
 *     if (res == "curated-boxes" || meta.page.pageType == "collections" || tag_name != "") {
 *       event.preventDefault();
 *       $(".card_popup").show(), myFunction()        // gift-box card chooser
 *     } else {
 *       window.location.href = "/cart";              // <- everything else
 *     }
 *   });
 *
 * That else branch is why adding any normal product jumps to the cart page:
 * the drawer never gets a chance. It also carries a dead comparison —
 * meta.page.pageType is "collection" (singular) on Shopify, never
 * "collections" — so that clause has never once matched.
 *
 * WHY THIS ISN'T FIXED IN theme.js
 *
 * theme.js is a COMPILED build artifact (it ships with a theme.js.map).
 * Editing it directly would be undone the next time the original developers
 * rebuild from source. So we leave their file alone and correct the behaviour
 * at runtime instead. The proper long-term fix is a one-line change in their
 * source repo, after which this file can simply be deleted.
 *
 * WHAT THIS DOES
 *
 * Re-binds their handler behind a guard. Gift-box products still run THEIR
 * original function, untouched — we hold a reference to it and call it, so
 * none of the Build-A-Box logic is reimplemented here. Everything else is
 * left alone entirely, which lets Impulse's own ajax add the item and open
 * the drawer.
 *
 * Fails safe: if the handler can't be found, this does nothing at all and
 * the site behaves exactly as it did before.
 */
(function () {
  'use strict';

  var SELECTOR = 'form[action="/cart/add"]';
  var MAX_WAIT_MS = 8000;
  var POLL_MS = 100;
  var installed = false;
  var original = null;

  function isGiftBoxContext() {
    // Their two real signals, preserved verbatim in meaning:
    //   1. browsing inside the curated-boxes collection
    //   2. the product carries a curated-boxes collection handle
    if (/curated-boxes/.test(window.location.href)) return true;
    var tagEl = document.getElementById('box_tag_name');
    return !!(tagEl && tagEl.value !== '');
  }

  function findOriginalHandler($) {
    var events;
    try {
      events = $._data(document, 'events');
    } catch (e) {
      return null;
    }
    if (!events || !events.submit) return null;

    for (var i = 0; i < events.submit.length; i++) {
      var h = events.submit[i];
      if (h && h.selector === SELECTOR && typeof h.handler === 'function' && !h.handler.__ssWrapped) {
        return h.handler;
      }
    }
    return null;
  }

  function install() {
    if (installed) return true;

    var $ = window.jQuery;
    if (!$ || !$._data) return false;

    original = findOriginalHandler($);
    if (!original) return false;

    function wrapped() {
      // Gift boxes are handled in the capture listener below, before Impulse's
      // own form handler can run. Anything reaching here is a normal product,
      // so we do nothing and let the theme's ajax open the drawer.
    }
    wrapped.__ssWrapped = true;

    $(document).off('submit', SELECTOR);
    $(document).on('submit', SELECTOR, wrapped);

    installed = true;
    return true;
  }

  /**
   * Gift boxes: intercept in the CAPTURE phase, before Impulse's own form-level
   * submit handler gets the event.
   *
   * With the cart drawer switched on, Impulse ajax-adds the item and opens the
   * drawer. Their card flow then adds the SAME item again after the customer
   * picks a card, and finishes on /cart. That is the double-add. So for gift
   * boxes we stop the event dead and run only their card flow, which ends on
   * the cart page exactly as it always did.
   */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || typeof form.closest !== 'function') return;
    form = form.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (!isGiftBoxContext()) return; // normal product: drawer, untouched

    e.preventDefault();
    e.stopImmediatePropagation();

    if (!original) install();
    if (original) {
      try { original.call(form, e); } catch (err) {}
    }
  }, true);

  if (install()) return;

  // theme.js may bind later than us; poll briefly, then give up quietly.
  var waited = 0;
  var timer = setInterval(function () {
    waited += POLL_MS;
    if (install() || waited >= MAX_WAIT_MS) clearInterval(timer);
  }, POLL_MS);

  document.addEventListener('DOMContentLoaded', install);
  window.addEventListener('load', install);
})();
